export default "/assets/website/images/plus.svg?85566e561479b0e785f16fef1bd991cb";